import { render, staticRenderFns } from "./WebChat.vue?vue&type=template&id=98f6ccd0&"
import script from "./WebChat.vue?vue&type=script&lang=js&"
export * from "./WebChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports